import actionTypes from '../actionTypes';

export const getDealMessages = (dealId) => ({
  type: actionTypes.DEAL_MESSAGES_GET_REQUEST,
  dealId,
});

export const sendDealMessage = (message) => ({
  type: actionTypes.DEAL_MESSAGE_SEND_REQUEST,
  message,
});

export const updateDealMessage = (dealId, messageId, message) => ({
  type: actionTypes.DEAL_MESSAGE_UPDATE_REQUEST,
  dealId,
  messageId,
  message,
});

export const deleteDealMessage = (dealId, messageId) => ({
  type: actionTypes.DEAL_MESSAGE_DELETE_REQUEST,
  dealId,
  messageId,
});



// WEBPACK FOOTER //
// src/redux/actions/dealMessages.js